import httpClient from './httpClient'

class OptimizationApi {
  static async get(insertionOrderId, menuId, goalType) {
    try {
      const res = await httpClient.get(
        `/campaign/optimization/goalSetting?insertionOrderId=${insertionOrderId}&ownerProfileMenuId=${menuId}&goalType=${goalType}`,
      )
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  }
}

export default OptimizationApi
